module.exports = __webpack_public_path__ + "media/images/placeholder-circle-c4492bac3cc2c967a4176a6bbc4654e3.png";